import { render } from "./select-account-type.vue?vue&type=template&id=cc00212a&scoped=true"
import script from "./select-account-type.vue?vue&type=script&lang=js"
export * from "./select-account-type.vue?vue&type=script&lang=js"

import "./select-account-type.vue?vue&type=style&index=0&id=cc00212a&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc00212a"]])

export default __exports__